import React from 'react';
import '../css/dataTables.css';


const renderTableBody = (headers, data, action, EditPartnerGrp) => {
    let body = "";

    body = data.map((register, index) => {

        return (
            <tr key={index}>
                <td style={{ textAlign: "center", width: 100 }}>
                    <button type="button" className="btn btn-sm "
                        onClick={() => EditPartnerGrp( index )}
                        style={{ fontWeight: '500', backgroundColor: "transparent", color: "#EABF28" }}>
                        <i className="fas fa-edit  fa-lg"></i>
                    </button>
                </td>
                <td>{register.GroupCode || ""}</td>
                <td> {register.GroupName || ""}</td>
                <td style={{ textAlign: "center", width: 100 }}>
                    <button type="button" className="btn btn-sm "
                        onClick={() => action({ index })}
                        style={{ fontWeight: '500', backgroundColor: "transparent", color: "#EABF28" }}>
                        <i className="fas fa-check"></i>
                    </button>
                </td>
            </tr>
        )
    })

    return body;
};

const renderTable = (headers, data, action, EditPartnerGrp) => {
    let header = "";
    let body = "";

    if (headers.length !== 0) {
        header = <tr>
            <td className="sticky-header table-header-yellow " style={{ width: 50 }}></td>
            <td className="sticky-header table-header-yellow ">{headers[0].title}</td>
            <td className="sticky-header table-header-yellow ">{headers[1].title}</td>
            <td className="sticky-header table-header-yellow " style={{ width: 100 }}></td>
        </tr>;
    }

    body = renderTableBody(headers, data, action, EditPartnerGrp);

    let table = "";

    table =
        <div className="table-wrapper-scroll-y my-custom-scrollbar">
            <table id="dataTableCreate" className="display" style={{ width: '100%' }}>
                <thead className="table-header">
                    {header}
                </thead>
                <tbody>
                    {body}
                </tbody>
            </table>
        </div>;

    return table;

};

export const renderTableGroupCodeModal = (headers, data, action, EditPartnerGrp) => {

    return renderTable(headers, data, action, EditPartnerGrp);

}
